import styled from "styled-components/macro";
import Theme from "../../constants/Theme";
import Typography from "../../atoms/typography";
import {
  DPIconKeyVector,
  DPIconRightArrowVector,
  DPIconTagVector,
  DPIconUpTime,
} from "../../assets/icons";
import { motion } from "framer-motion";

const features = [
  {
    title: "Fast Dispute Resolution",
    Icon: DPIconRightArrowVector,
    description:
      "You are just one call away from solving any issues you may encounter using our product. We have the best customer service team, try us",
  },
  {
    title: "Gives Access To Loan",
    Icon: DPIconKeyVector,
    description:
      "We know you may need loan at one point or the other in your business, that is why we have factored this in and you will be able to",
  },
  {
    title: "Offers Best Prices",
    Icon: DPIconTagVector,
    description:
      "We offer competitive prices for our transactions and you get to earn the high end of the local market",
  },
  {
    title: "99 Percent Uptime",
    Icon: DPIconUpTime,
    description:
      "While we may not promise you a 100%uptime we are sure of 99percent, we are sure to provide you with 24 hours services to perform your transactions at anytime of the day",
  },
];

const WhyDotPay = () => {
  let whyVariant = {};
  let whyGrandVariant = {};

  const isMobile = window.innerWidth < 768;

  if (!isMobile) {
    whyVariant = {
      start: { y: 100, opacity: 0 },
      end: {
        y: 0,
        opacity: 1,
        transition: {
          // delay: 0.5,
          when: "beforeChildren",
          staggerChildren: 0.5,
        },
      },
    };

    whyGrandVariant = {
      start: {
        x: 800,
        opacity: 0,
      },
      end: {
        x: 0,
        opacity: 1,
      },
    };
  }
  return (
    <WDP>
      <motion.div
        variants={whyVariant}
        initial="start"
        whileInView="end"
        viewport={{ once: true }}
        transition={{ delay: 0.5, duration: 1 }}
        className="WhyDotPay__WDP__wdp-container container"
      >
        <div>
          <Typography.Heading
            className="landing--text-summary"
            color="pending"
            weight="medium"
            level={3}
            uppercase
            fontType="Galano"
          >
            Why dotpay?
          </Typography.Heading>
          <Typography.Heading
            className="WhyDotPay__WDP--phrase"
            color="darkBlue"
            weight="medium"
            level={1}
            fontType="Galano Alt"
          >
            You have access to a system that gives
          </Typography.Heading>
        </div>
        <div className="WhyDotPay__WDP__wdp-container--xtics-container">
          {features.map(({ title, Icon, description }) => (
            <motion.div
              variants={whyGrandVariant}
              transition={{ type: "spring", stiffness: 50, duration: 0.8 }}
              className="WhyDotPay__WDP--features"
              key={title}
            >
              <Icon />
              <Typography.Heading
                className="WhyDotPay__WDP__wdp-container--xtics-container--xtics-title"
                fontType="Galano Alt"
                color="matteBlack"
                weight="semiBold"
                uppercase
                level={3}
              >
                {title}
              </Typography.Heading>
              <Typography.Text
                className="WhyDotPay__WDP__wdp-container--xtics-container--xtics-text"
                fontType="Galano Alt"
                weight="normal"
                color="matteBlack"
              >
                {description}
              </Typography.Text>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </WDP>
  );
};
const WDP = styled.div`
  width: 100%;
  padding-bottom: 160px;
  background: linear-gradient(#ffffff, #e4ffe1);

  @media screen and (max-width: 768px) {
    padding-bottom: 50px;
    padding-top: 100px;
  }
  .WhyDotPay__WDP {
    &__wdp-container {
      &--xtics-container {
        padding: 40px 0 0 0;
        display: grid;
        grid-template-columns: auto auto auto auto;
        gap: 40px;
        overflow: auto;
        /* justify-content: space-between; */
        &--xtics-title {
          width: 180px;
          margin: 20px 0;
          font-size: ${Theme.fontSizes.xlarge};
        }
        &--xtics-text {
          line-height: 24px;
        }
      }
    }
    &--features {
      min-width: 240px;
      /* margin-right: 20px;
      &:last-child {
        margin-right: 0;
      } */
    }
    &--phrase {
      font-size: ${Theme.fontSizes.medium};
      @media screen and (min-width: 768px) {
        font-size: ${Theme.fontSizes.extralarge};
      }
    }
  }
`;

export default WhyDotPay;
